import { Button, Card, Select, Space, Table, DatePicker, TableProps, Tag, Tooltip, Typography, Pagination, Modal, Spin, Switch, ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

interface IProps{
    completedDate: string
    visible: boolean,
    onCancel: () => void
    onSave: (date: string) => void
}
export const MilestoneEditStatusModal: React.FC<IProps> = (props) => {
    const [dateVal, setDateVal] = useState(props.completedDate ? props.completedDate : null);
    useEffect(() => {
        setDateVal(props.completedDate ? props.completedDate : null)
    }, [props.completedDate])
    const onSave = () => {
        if(!dateVal) return
        props.onSave(dateVal);
    }
    const onDateChange = (val: string) => {
        setDateVal(val)
    }
    return (
        <Modal title="请选择完成时间" width="fit-content" destroyOnHidden maskClosable={false} open={props.visible} onCancel={props.onCancel} footer={null}>
            <div>
                <div className="text-xs text-red-500">* 请注意已完成状态的里程碑保存后将不可编辑</div>
                <div className="flex justify-between items-center p-3">
                    <DatePicker defaultValue={props.completedDate && dayjs(props.completedDate)}
                        value={dateVal && dayjs(dateVal)}
                        showNow={false} onChange={(_, dateStr) => onDateChange(dateStr as string)} />
                    <div className="flex">
                        <Button className="ml-4" onClick={props.onCancel}>
                            取消
                        </Button>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorPrimary: "#161616",
                                }
                            }}>
                            <Button type="primary" className="ml-4" onClick={onSave}>
                                保存
                            </Button>
                        </ConfigProvider>
                    </div>
                </div>

            </div>
        </Modal>
    )
}